module.exports = __webpack_public_path__ + "img/logo11.9cd3eb02.png";